import { formatMoney } from "../booking/money.js";

/**
 * Historical booking price shown in the appointment drawer.
 *
 * `Booking.price` belongs to the participant row, so only claim one lesson
 * price when this drawer represents exactly one active participant. Shared
 * appointments may carry different participant prices and must not collapse
 * them into the first booking's value.
 */
export function lessonPriceLabel(
  price: string | null | undefined,
  participantCount: number,
): string | null {
  if (participantCount !== 1 || price === null || price === undefined) return null;
  return formatMoney(price, "GBP");
}
